import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as InstitutionActions from '../actions/Institution';
import InstitutionsList from '../components/InstitutionsList';

function mapStateToProps(state) {
  return {
    institution: state.institution,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    institutionActions: bindActionCreators(InstitutionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstitutionsList);



// WEBPACK FOOTER //
// ./src/containers/InstitutionsList.js